import axios from 'axios';

const DB_NAME = 'dandis';
const USER_KEY = 'pos-authenticated-user';

const AuthService = {
    async authenticateUser(username, password) {
        console.log('Autenticando usuario:', username);
        try {
            const response = await axios.post(
                '/authenticate_user',
                {
                    username,
                    password,
                    db: DB_NAME
                },
                {
                    timeout: 10000,
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            const result = response?.data;

            if (result && result.success && result.user_id) {
                console.log('Usuario autenticado exitosamente');
                const userData = {
                    user_id: result.user_id,
                    username: result.username,
                    name: result.name
                };
                this.saveUser(userData);
                return userData;
            }

            throw new Error(result?.error || 'Error en autenticacion');

        } catch (error) {
            console.error('Error en autenticacion:', error?.response?.data?.error || error?.message || error);
            throw new Error(error?.response?.data?.error || 'No se pudo autenticar con el servidor');
        }
    },

    saveUser(userData) {
        localStorage.setItem(
            USER_KEY,
            JSON.stringify({ ...userData, timestamp: Date.now() })
        );
        console.log('Usuario guardado:', userData);
    },

    getUser() {
        const userJson = localStorage.getItem(USER_KEY);
        if (!userJson) return null;
        try {
            const data = JSON.parse(userJson);
            return {
                user_id: data.user_id,
                username: data.username,
                name: data.name
            };
        } catch (error) {
            console.error('Error al parsear usuario:', error);
            return null;
        }
    },

    isAuthenticated() {
        return this.getUser() !== null;
    },

    logout() {
        localStorage.removeItem(USER_KEY);
        console.log('Usuario deslogueado');
    },

    clearAll() {
        this.logout();
    }
};

export default AuthService;